import { DBField } from './db.field';

export class Responsable {
  public Ident: string;
  public NomfaPER: string;
  public Pre01PER: string;
  public NeproPER: string;

  constructor() {
    this.Ident = '';
    this.NomfaPER = '';
    this.Pre01PER = '';
    this.NeproPER = '';
  }
}

/* ------------------------------------------------------ */

export class Address {
  public Ident: string;
  public Adre1ADR: string;
  public Adre2ADR: string;
  public Adre3ADR: string;
  public DenomADR: string;
  public VilleADR: string;
  public FormatADR: string;
}

/* ------------------------------------------------------ */

export class Catalog {
  public Ident: string;
  public Name_CTL: string;
  public DeparCTL: string;
  public ImgExCTL: string;
  public ImgSrc: string;
  public TotCategories: number;
  public ListCategory: Category[];
}

/* ------------------------------------------------------ */

export class Category {
  public Ident: string;
  public User_CAT: string;
  public Nom__CAT: string;
  public Desc_CAT: string;
  public ImgExCAT: string;
  public ImgSrc: string;
  public TotProducts: number;
  public IdCataloguePere: string;
  public ParentCatalogue: Catalog;
  public ListProduct: Product[];
}

/* ------------------------------------------------------ */

export class Product {
  Ident: string;
  Code_PRO: string;
  DescrPRO: string;
  DesigPRO: string;
  DureePRO: string;
  // Prix_PRO: string;
  PricesList: Array<ProductPrice>;
  NiforPRO: string;
  //PartiPRO: string;
  PubliPRO: string;
  PreRePRO: string;
  ProgrPRO: string;
  PedagPRO: string;
  PrestPRO: string;
  PjextPRO: string;

  IdCategoriePere: string;
  Responsable: Responsable;
  ParentCategory: Category;
  ProductStagesList: Stage[];
  OptionalFields: DBField[];
}
export class ProductLink {
  public Ident: string;
  public Code_PRO: string;
  public DescrPRO: string;
  public DesigPRO: string;
  public DureePRO: string;
  // public Prix_PRO: string;
  PricesList: Array<ProductPrice>;
  public NiforPRO: string;
  public PubliPRO: string;
  public PreRePRO: string;
  public ProgrPRO: string;
  public PedagPRO: string;
  public PrestPRO: string;
  public PjextPRO: string;
  public ResponsableList: Array<Responsable>;
  public ParentCategoryList: Array<Category>;
  public StagesList: Array<Stage>;
  public OptionalFields: Array<DBField>;
}


/* ------------------------------------------------------ */

export class Stage {
  public Ident: string;
  public NumstPRO: string;
  public ProduPRO: string;
  public Info_PRO: string;
  //public CouniPRO: string;
  public datedPRO: Date;
  public DatedPro: string;
  public datefPRO: Date;
  public DatefPro: string;
  public PrestPRO: string;
  public DureePRO: string;
  public PjextPRO: string;
  public PartiPRO: string;
  public CapstPRO: string;
  public NbstaPRO: string;

  public ProductPreRePRO: string;
  public ProductProgrPRO: string;
  public ProductPedagPRO: string;
  public PricesList: Array<StagePrice>;

  year: number;
  month: number;
  DetailsFileName: string;

  ResponsablesList: Responsable[];
  AddressesList: Address[];
  ParentProduct: Product;
  StageCyclesList: Cycle[];
  OptionalFields: DBField[];
}

export class StageMonth {
  MonthsNumber: number;
  MonthDef: string;
}

export class StageYear {
  Year: number;
  MonthsList: StageMonth[];
}

export class StagePrice {
  public Value: string;
  public Label: string;
  public Tooltip: string;
  public Order: string;
  public Selected: boolean;
}
export class ProductPrice extends StagePrice {
  constructor() {
    super()
  }
}
/* ------------------------------------------------------ */

export class Cycle {
  public Ident: string;
  public ValueDOS: string;
  public Body_DOS: string;
  public dateDDos: Date;
  public dateFDOS: Date;
  public PjextDOS: string;
  public PriCyDOS: string;
  public NbHeuDOS: string;

  year: number;
  month: number;
  DateDDos: string;
  DateFDOS: string;
  StageCycle: Stage[];
  ResponsableCycle: Responsable;

  constructor() {
    this.Ident = '';
    this.ValueDOS = '';
    this.Body_DOS = '';
    this.dateDDos = new Date;
    this.DateDDos = '';
    this.dateFDOS = new Date;
    this.DateFDOS = '';
    this.PjextDOS = '';
    this.PriCyDOS = '';
    this.year = 0;
    this.month = 0;
    this.StageCycle = [];
    this.ResponsableCycle = new Responsable;

  }
}

export class CycleMonth {
  MonthsNumber: number;
  MonthDef: string;
}

export class CycleYear {
  Year: number;
  MonthsList: CycleMonth[];
}

/* ------------------------------------------------------ */

export class Contact {
  public Ident: string;
  public CivilPER: string;
  public Pre01PER: string;
  public NomfaPER: string;
  public NeproPER: string;
  public IsSelected: boolean;
}

/* ------------------------------------------------------ */

export class Client {
  public Ident: string;
  public RaisoCLI: string;
  public ListContact: Contact[];
}

/* ------------------------------------------------------ */

export class AppRoutes {
  readonly HOME: string = '/home/base';

  readonly CATALOGS: string = '/catalogsFormations/catalogs';
  readonly CATEGORIES: string = '/catalogsFormations/categories';
  readonly PRODUCTS: string = '/catalogsFormations/products';
  readonly PRODUCTLINK: string = '/catalogsFormations/productlink';

  readonly CYCLESLIST: string = '/cursus/cyclelist';
  readonly CYCLEDETAILS: string = '/cursus/cyclefile';

  readonly ELEARNINGLIST: string = '/e-learning/lists';
  readonly ELEARNINGDETAILS: string = '/e-learning/details';

  readonly STAGESLIST: string = '/stages/lists';
  readonly STAGEDETAILS: string = '/stages/details';

  readonly FORMMIXED: string = '/inscriptions/formulaire';
  readonly FORMEXTRANET: string = '/inscriptions/extranet';

  readonly ADMINCATALOGS: string = '/admin/catalogs';
  readonly ADMINCYCLES: string = '/admin/cycles';
  //readonly ADMINCONFIG: string = '/admin/config';
}

/* ------------------------------------------------------ */

export class InitParams {
  access: string;
  mode: string;
  //////typeInscription: string;
  sample: string;
  siteUrl: string;
  apiUrl: string;

  goToCycleList: string;                  // if contains "1", redirects to          /cursus/cyclelist
  goToStageList: string;                  // if contains "1", redirects to          /stages/lists
  goToCatalogueList: string;              // if contains "1", redirects to          /catalogsFormations/catalogs

  goToCategories_ByCatalogueID: string;   // if contains CatalogueID, redirects to  /catalogsFormations/categories     
  goToProducts_ByCategorieID: string;     // if contains CategoryID, redirects to   /catalogsFormations/products          

  goToProduct_ByID: string;               // if contains ProductID, redirects to    /catalogsFormations/productlink
  goToCycle_ByID: string;                 // if contains CycleID, redirects to      /cursus/cyclefile
  goToStage_ByID: string;                 // if contains StageID, redirects to      /stages/details

  goToProductForm: string;                // if contains ProductID, redirects to    /inscriptions/formulaire
  goToCycleForm: string;                  // if contains CycleID, redirects to      /inscriptions/formulaire
  goToStageForm: string;                  // if contains StageID, redirects to      /inscriptions/formulaire


  //////catalogueId: string;      // redirect to catalogues'list page (querystring &ctl=[idCatalogue])
  //////categorieId: string;      // redirect to products'list page (querystring &cte=[idCategorie])
  //////productId: string;        // redirect to product page (querystring &pr=[idProduct])
  //////stageId: string;          // redirect to formulaire page (querystring &stg=[idStage])

  isAdmin: boolean;

  constructor() {
    this.access = 'EMPTY';
    this.mode = 'EMPTY';
    this.sample = '';
    this.siteUrl = '';
    this.apiUrl = '';
    //this.productId = '';
    this.isAdmin = false;

    this.goToCycleList = '';
    this.goToStageList = '';
    this.goToCatalogueList = '';

    this.goToCategories_ByCatalogueID = '';
    this.goToProducts_ByCategorieID = '';

    this.goToProduct_ByID = '';
    this.goToCycle_ByID = '';
    this.goToStage_ByID = '';

    this.goToProductForm = '';
    this.goToCycleForm = '';
    this.goToStageForm = '';
  }
}

/* ------------------------------------------------------ */

//////export class DataSession {
//////  items: SessionItem[];
//////  constructor() {
//////    this.items = new Array();
//////  }
//////}

/* ------------------------------------------------------ */

export class SessionItem {
  type: eItem;
  id: string;
  code: string;
  desc: string;
  jsData: string;
  responsable: Responsable;

  constructor(itemType: eItem) {
    this.type = itemType;
    this.id = '';
    this.code = '';
    this.desc = '';
    this.jsData = '';
  }
}

export enum eItem {
  NONE,
  CYCLE,
  STAGE,
  PRODUCT,
  CATEGORY,
  CATALOG
}

/* ------------------------------------------------------ */

